import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgLocationPin = (props: SVGProps<SVGSVGElement>) => (
  <svg
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      clipRule="evenodd"
      d="M8 9.333A2.667 2.667 0 1 0 8 4a2.667 2.667 0 0 0 0 5.333Z"
      stroke="#919499"
    />
    <path
      d="M4.582 3.458a4.833 4.833 0 1 1 6.836 6.835L8 13.712l-3.418-3.418a4.833 4.833 0 0 1 0-6.835Z"
      stroke="#919499"
    />
  </svg>
);
const Memo = memo(SvgLocationPin);
export default Memo;
